import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import VueCookies from "vue-cookies";
import "material-icons/iconfont/material-icons.css";
import Vuetify from "vuetify";
import "vuetify/dist/vuetify.min.css";
import vuetify from "./plugins/vuetify";
import i18n from "./i18n";
import VueToast from "vue-toastification";
import "vue-toastification/dist/index.css";
Vue.use(VueToast, {
  position: localStorage.getItem("YPlang") == "ar" ? "top-left" : "top-right",
});
Vue.use(VueCookies, { expires: "1d" });

Vue.component("studentAuto", () =>
  import(
    /* webpackChunkName: "autoCompleteOfStudent" */ "./components/studentAutoComplete.vue"
  )
);
Vue.component("noteTypeAuto", () =>
  import(
    /* webpackChunkName: "autoCompleteOfNotes" */ "./components/typeNotesAutoComplete.vue"
  )
);
Vue.component("courseAuto", () =>
  import(
    /* webpackChunkName: "autoCompleteOfCourse" */ "./components/courseAutoComplete.vue"
  )
);
Vue.component("mainLoader", () =>
  import(
    /* webpackChunkName: "loader" */ "./components/loader.vue" /* webpackPrefetch: true */
  )
);

Vue.component("data-table", () =>
  import(
    /* webpackChunkName: "dataTable" */ "./components/table.vue" /* webpackPrefetch: true */
  )
);
Vue.component("filter-table", () =>
  import(/* webpackChunkName: "filterTable" */ "./components/filter.vue")
);
Vue.component("create-dialog", () =>
  import(/* webpackChunkName: "createDialog" */ "./components/create.vue")
);
Vue.component("deleteDialog", () =>
  import(/* webpackChunkName: "deleteDialog" */ "./components/delete.vue")
);
Vue.component("edit-dialog", () =>
  import(/* webpackChunkName: "editDialog" */ "./components/edit.vue")
);

Vue.use(Vuetify);

Vue.config.productionTip = false;
new Vue({
  router,
  vuetify,
  i18n,
  render: (h) => h(App),
}).$mount("#app");
